import { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import LearnMoreModalClose from "./LearnMoreModalClose";

interface Props {
  open : any,
  handleClose (): void,
  link : string
}

const LearnMoreModal = ({ open, handleClose, link } : Props) => {
  const iframeContent = useRef<null | HTMLIFrameElement>(null);
  const randomNumberInRange = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  return (
    <Modal
      centered={true}
      show={open}
      size="lg"
      onHide={handleClose}
      radius="40px"
    >
      <div
        className={`modal_learn_more_background d-flex flex-column gap-4 `}
      >
        <div className="w-100" style={({ height: "5vh" })}>
          <LearnMoreModalClose handleClose={handleClose} />
        </div>
        <iframe
          title="learn-more-iframe"
          key={randomNumberInRange(10000, 999)}
          src={link}
          className="w-100"
          style={({ height: "80vh", overflowY: "hidden" })}
          ref={iframeContent}
        />
      </div>
    </Modal>
  );
};

export default LearnMoreModal;
